import createIcon from '../../createIcon';

/**
 * @component @name Villa
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAyMUgzVjhMMTYgM1YxMEg3VjIxWk0xOSAxMEMxNy45IDEwIDE3IDEwLjkgMTcgMTJIOVYyMUgxNFYxNkgxNlYyMUgyMVYxMkMyMSAxMC45IDIwLjEgMTAgMTkgMTBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Villa = createIcon('Villa', [
  [
    'path',
    {
      d: 'M7 21H3V8L16 3V10H7V21ZM19 10C17.9 10 17 10.9 17 12H9V21H14V16H16V21H21V12C21 10.9 20.1 10 19 10Z',
      key: 'k5d6kw',
    },
  ],
]);

export default Villa;
